// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1l8mN","row":"styles_row__1DA1j"};